<template>
  <div class="detail-wrap">
    <div class="detail">
      <!--tabs-->
      <div class="tab-group">
        <el-tabs
          v-model="activeName">
          <el-tab-pane
            v-for="item in editableTabs"
            :key="item.key"
            :label="item.label"
            :name="item.key"></el-tab-pane>
        </el-tabs>
      </div>
      <!--基本信息-->
      <custom-detail v-loading="loading" styleType="singleRow" :detailData="displayBaseInfo"></custom-detail>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import dayjs from 'dayjs'
import CustomDetail from '@/components/CustomDetail/index'
import { getEventMessageDetail } from '@/api/event/list'
import { useI18n } from 'vue-i18n'
import { GlobalColor } from '@/utils/globalColor'
const { t } = useI18n()
const activeName = ref('1')
const loading = ref(false)
const showOwnershipInfo = ref(true)
const editableTabs = [
  {
    key: '1',
    label: t('host.overview')
  }
]
const baseInfo = ref([
  {
    title: t('resources.baseInfo'),
    content: [
      {
        key: t('log.log_name'),
        name: 'display_name',
        value: ''
      },
      {
        key: t('alarm.resource_name'),
        name: 'resource',
        value: ''
      },
      {
        key: t('alarm.resource_type'),
        name: 'display_resource_type',
        value: ''
      },
      {
        key: t('alarm.event_result'),
        name: 'display_result',
        value: ''
      },
      {
        key: t('log.remote_ip'),
        name: 'remote_ip',
        value: ''
      },
      {
        key: t('user.description'),
        name: 'description',
        value: ''
      },
      {
        key: t('table.occurred_at'),
        name: 'occurred_at',
        value: ''
      }
    ]
  },
  {
    prop: 'ownership_info',
    title: t('alarm.ownership_info'),
    content: [
      {
        key: t('user.tenantID'),
        name: 'project_id',
        value: ''
      },
      {
        key: t('alarm.tenant_name_label'),
        name: 'enterprise_name',
        value: ''
      },
      {
        key: t('user.user_id'),
        name: 'user_id',
        value: ''
      },
      {
        key: t('user.userName'),
        name: 'username',
        value: ''
      },
      {
        key: t('user.nickName'),
        name: 'nickname',
        value: ''
      }
    ]
  },
  {
    title: t('alarm.resource_info'),
    content: [
      {
        name: 'metadata',
        valueTooltipHide: true
      }
    ]
  },
  {
    title: t('table.detail'),
    content: [
      {
        name: 'detail_info',
        valueTooltipHide: true
      }
    ]
  }
])
const displayBaseInfo = computed(() => baseInfo.value.filter(item => item.prop !== 'ownership_info' || showOwnershipInfo.value))
const getDetailFun = async(id) => {
  loading.value = true
  try {
    const res = await getEventMessageDetail(id)
    const detailData = res.data.event_message
    detailData.occurred_at = detailData.occurred_at ? dayjs(detailData.occurred_at).format('YYYY-MM-DD HH:mm:ss') : ''
    for (const i in baseInfo.value[0].content) {
      const name = baseInfo.value[0].content[i].name
      if (name === 'display_result') {
        baseInfo.value[0].content[i].value = `<i class="${detailData.result}" style="margin-right:4px;"></i>${detailData[name]}`
      } else {
        baseInfo.value[0].content[i].value = detailData[name]
      }
    }
    for (const i in baseInfo.value[1].content) {
      const name = baseInfo.value[1].content[i].name
      baseInfo.value[1].content[i].value = detailData[name]
      baseInfo.value[1].content[i].valueHide = !detailData[name]
    }
    showOwnershipInfo.value = !!(detailData.enterprise_name || detailData.username)
    baseInfo.value[2].content[0].value = `<pre style="white-space: pre-wrap;">${JSON.stringify(detailData.metadata || {}, null, 2)}</pre>`
    baseInfo.value[2].content[0].style = { width: '100%' }
    baseInfo.value[2].content[0].valueStyle = { background: GlobalColor.$grey2, padding: '8px 16px' }
    baseInfo.value[3].content[0].value = `<pre style="white-space: pre-wrap;">${JSON.stringify(detailData.detail_info || {}, null, 2)}</pre>`
    baseInfo.value[3].content[0].style = { width: '100%' }
    baseInfo.value[3].content[0].valueStyle = { background: GlobalColor.$grey2, padding: '8px 16px' }
    loading.value = false
  } catch (error) {
    loading.value = false
  }
}
defineExpose({
  getDetailFun
})
</script>

<style lang="scss">
.metadata {
  display: block;
  padding-left: 20px;
  .metadata-info {
    padding-left: 6px;
  }
}
</style>
